import { useState } from 'react';
import PropTypes from 'prop-types';
import CircleQuestionMarkEmptyIcon from 'dibs-icons/exports/legacy/CircleQuestionMarkEmpty';
import CircleQuestionMarkFilledIcon from 'dibs-icons/exports/legacy/CircleQuestionMarkFilled';
import styles from './styles/HoverableQuestionMarkIcon.scss';

function HoverableQuestionMarkIcon({ className = '' }) {
    const [isMouseOn, setIsMouseOn] = useState(false);

    return (
        <div
            style={{ fill: 'yellow' }}
            className={styles.wrapper}
            onMouseEnter={() => setIsMouseOn(true)}
            onMouseLeave={() => setIsMouseOn(false)}
        >
            {isMouseOn ? (
                <CircleQuestionMarkFilledIcon className={className} />
            ) : (
                <CircleQuestionMarkEmptyIcon className={className} />
            )}
        </div>
    );
}

HoverableQuestionMarkIcon.propTypes = {
    className: PropTypes.string,
};

export default HoverableQuestionMarkIcon;
